import { render, staticRenderFns } from "./theoryHistoryList.vue?vue&type=template&id=7b8bb1ca&scoped=true"
import script from "./theoryHistoryList.vue?vue&type=script&lang=js"
export * from "./theoryHistoryList.vue?vue&type=script&lang=js"
import style0 from "./theoryHistoryList.vue?vue&type=style&index=0&id=7b8bb1ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bb1ca",
  null
  
)

export default component.exports